import {
  KubernetesSecurityTypeSpecificData,
  KubernetesSecurityPolicyPayload,
} from './types';

/**
 * Builds the API payload from form data
 * Wraps values in Directive structure as expected by backend
 */
export function buildKubernetesSecurityPayload(
  formData: KubernetesSecurityTypeSpecificData
): KubernetesSecurityPolicyPayload {
  return {
    restrictDefaultNamespace: {
      value: formData.restrictDefaultNamespace,
      enforce: false,
    },
    restrictSecrets: {
      value: formData.restrictSecrets,
      enforce: false,
    },
    enableNodeShell: {
      value: formData.enableNodeShell,
      enforce: false,
    },
    enablePodSecurityConstraints: {
      value: formData.enablePodSecurityConstraints,
      enforce: false,
    },
    privilegedContainers: {
      value: {
        enabled: formData.restrictPrivilegedContainers,
      },
      enforce: false,
    },
    hostNamespaces: {
      value: {
        enabled: formData.restrictHostNamespace,
      },
      enforce: false,
    },
    hostPorts: {
      value: {
        enabled: formData.restrictHostNetworkingPorts,
        hostNetwork: formData.hostNetwork,
        min: formData.hostPortMin,
        max: formData.hostPortMax,
      },
      enforce: false,
    },
    volumeTypes: {
      value: {
        enabled: formData.restrictVolumeTypes,
        allowedTypes: formData.allowedVolumeTypes,
      },
      enforce: false,
    },
    hostFilesystem: {
      value: {
        enabled: formData.restrictHostFilesystemPaths,
        allowedPaths: formData.allowedHostPaths,
      },
      enforce: false,
    },
    allowFlexVolumes: {
      value: {
        enabled: formData.restrictDrivers,
        allowedVolumes: formData.allowedFlexVolumeDrivers,
      },
      enforce: false,
    },
    readOnlyRootFileSystem: {
      value: {
        enabled: formData.requireReadOnlyRootFilesystem,
      },
      enforce: false,
    },
    users: {
      value: {
        enabled: formData.restrictUserAndGroupIds,
        runAsUser: {
          type: formData.runAsUserType,
          idrange: formData.runAsUserRanges,
        },
        runAsGroup: {
          type: formData.runAsGroupType,
          idrange: formData.runAsGroupRanges,
        },
        supplementalGroups: {
          type: formData.supplementalGroupsType,
          idrange: formData.supplementalGroupsRanges,
        },
        fsGroups: {
          type: formData.fsGroupType,
          idrange: formData.fsGroupRanges,
        },
      },
      enforce: false,
    },
    allowPrivilegeEscalation: {
      value: {
        enabled: formData.restrictEscalationToRootPrivileges,
      },
      enforce: false,
    },
    capabilities: {
      value: {
        enabled: formData.restrictLinuxCapabilities,
        allowedCapabilities: formData.allowedCapabilities,
        requiredDropCapabilities: formData.requiredDropCapabilities,
      },
      enforce: false,
    },
    selinux: {
      value: {
        enabled: formData.restrictSeLinuxSecurityContext,
        allowedCapabilities: formData.seLinuxOptions,
      },
      enforce: false,
    },
    allowProcMount: {
      value: {
        enabled: formData.restrictProcMountTypes,
        procMountType: formData.procMountType,
      },
      enforce: false,
    },
    appArmor: {
      value: {
        enabled: formData.restrictAppArmorProfiles,
        AppArmorType: formData.allowedAppArmorProfiles,
      },
      enforce: false,
    },
    secComp: {
      value: {
        enabled: formData.restrictSeccompProfiles,
        secCompType: formData.allowedSeccompProfiles,
      },
      enforce: false,
    },
    forbiddenSysctlsList: {
      value: {
        enabled: formData.restrictSysctlProfiles,
        requiredDropCapabilities: formData.forbiddenSysctls,
      },
      enforce: false,
    },
  };
}
